export const selectElementContent = (element: HTMLElement) => {
  const range = document.createRange();
  range.selectNodeContents(element);
  const selection = window.getSelection();
  selection?.removeAllRanges();
  selection?.addRange(range);
};

declare global {
  /** Handy shortcut for `console.log`. Works only in `development` and `test`. */
  const _log: typeof console.log;
}

window._log = (...args) => {
  // if call to this method sneaks to the production code, ensure it does nothing and is tree-shaken.
  if (process.env.NODE_ENV !== 'development' && process.env.NODE_ENV !== 'test') return;
  // eslint-disable-next-line no-console
  console.log(...args);
};
